module.exports = __webpack_public_path__ + "img/1_no.21996d2c.svg";